import {
    Directive,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChange
} from '@angular/core'

import { nullCheck } from '../helpers/validate'
import { MapService } from '../providers/mapService'
import { Point } from '../types/Point'
import {BCanvasLayer, CanvasLayerOptions} from "../types/CanvasLayer";
import {BMapInstance} from "../types/Map";
import {CircleOutsideOptions} from "../types/CircleOutside";


@Directive({
  selector: 'circle-outside'
})
export class CircleOutsideComponent implements OnInit, OnChanges, OnDestroy {
  @Input() private center: Point
  @Input() private radius: number
  @Input() private options: CircleOutsideOptions

  @Output() private loaded = new EventEmitter()

  canvasOptions: CanvasLayerOptions = {}

  private circleOutside: BCanvasLayer

  constructor(private _service: MapService) {}

  public ngOnInit() {
    nullCheck(this.center, 'center is required for <circle>')
    nullCheck(this.radius, 'center is required for <circle>')

    this._service
      .addCanvasLayer((map: BMapInstance) => {

          let self = this;
          function update() {
              var that: any = this;
              let ctx: CanvasRenderingContext2D = that.canvas.getContext('2d');

              console.log("zoom is " + map.getZoom());

              if (!ctx) {
                  return;
              }

              ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
              ctx.fillStyle = "rgba(33, 33, 33, 0.3)";


              let width = ctx.canvas.width;
              let height = ctx.canvas.height;
              ctx.beginPath();
              ctx.fillRect(-0, -0, width, height);

              let pixel = map.pointToPixel(self.center);
              let radius = self.getPiexValueByRealDistance(map, self.radius);

              var stepClear=1;//å«å¿è®°è¿ä¸æ­¥
              clearArc(pixel.x,pixel.y,radius);

              // æ¸é¤ä»¥ x,y ä¸ºåå¿ï¼ radiusä¸ºåå¾çç»å¾
              function clearArc(x,y,radius){
                  var calcWidth=radius-stepClear;
                  var calcHeight=Math.sqrt(radius*radius-calcWidth*calcWidth);

                  var posX=x-calcWidth;
                  var posY=y-calcHeight;

                  var widthX=2*calcWidth;
                  var heightY=2*calcHeight;

                  if(stepClear<=radius){
                      ctx.clearRect(posX,posY,widthX,heightY);
                      stepClear+=1;
                      clearArc(x,y,radius);
                  }
              }
          }
        this.canvasOptions.update = update;
        return (this.circleOutside = new window.BMap.CanvasLayer(this.canvasOptions))
      })
      .then(() => {
        this.loaded.emit(this.circleOutside)
      })
  }

    getPiexValueByRealDistance(map: BMapInstance, realDistance:number) {
        // æ ¹æ®è¾å¥èå´å¼(åä½ï¼ç±³) è®¡ç®åºéè¦ç»çåºååç´ ï¼px
        var pointA = map.getCenter();
        var pointAPixel = map.pointToPixel(pointA);
        var pointB = new window.BMap.Point(pointA.lng, pointA.lat + 1);
        var pointBPixel = map.pointToPixel(pointB);
        //åç´ è·ç¦»
        var piexlDistanceBetween2Points = Math.abs(pointBPixel.y - pointAPixel.y);
        var realDistanceBetween2Points = map.getDistance(pointA, pointB);

        var pixelDistance = realDistance / (realDistanceBetween2Points / piexlDistanceBetween2Points);

        console.log("zoom is " + map.getZoom());
        console.log("realDistance is " + realDistance);
        console.log("pixelDistance is " + pixelDistance);

        return pixelDistance;
    }

  public ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
      console.log("changes is " + changes);
      console.log("options is " + this.options);
  }

  public ngOnDestroy() {
    this._service.removeCanvasLayer(this.circleOutside)
  }
}
